// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoice-number-table {
    margin: 0 0 0 auto;
}

.invoice-number-table td {
    padding: 4px;
    border-bottom: 1px solid #000;
}

.invoice-number-table h1 {
    letter-spacing: 3px;
    margin: 0;
}

.company-wrapper {
    height: 170px;
    font-size: 100%;
    overflow: hidden;
    margin-bottom: 20px;
}

.invoice-header-table td {
    vertical-align: top;
}

.print-table {
    width: 100%;
    font-size: 12px;
}

.text-bold {
    font-weight: bold;
}

.text-center {
    text-align: center;
}

.text-right {
    text-align: right;
}

.nowrap {
    white-space: nowrap;
}

.code {
    font-family: consolas;
}

.invoice-detail {
    width: 100%;
}

.invoice-detail th {
    border-top: 1px solid #000;
    border-bottom: 2px solid #000;
    padding: 3px 2px;
    white-space: nowrap;
}

.invoice-detail td {
    border-bottom: 1px solid #000;
    padding: 3px 2px;
}

.detail-wrapper {
    height: 600px;
    border-bottom: 1px solid #000;
}

.small td, .small th {
    font-size: 80%;
    padding: 1px;
}

.logo {
    max-height: 80px;
    max-width: 300px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
